import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const CenteredTemplateOneOneEight = ({
  backgroundType = "image",
  backgroundColor = null,
  backgroundImage = "/singleBg.png",

  contentImageOne = null,
  contentImageOnePreview = null,

  buttonLabel = "Register Now",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "20",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#32CD32",

  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  center = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  const defaultBackgroundImage = "/singleBg.png";
  const finalBackgroundImage =
    backgroundImage || backgroundImagePreview || defaultBackgroundImage;

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-auto min-h-[283px]" : center ? "!h-[50vh]" : "!h-[15vh]"
      } w-full flex flex-col mx-auto items-center justify-between px-4 md:px-8 py-4 md:py-3 overflow-hidden`}
      style={{
        backgroundImage: `url(${
          finalBackgroundImage instanceof File
            ? backgroundImagePreview
            : finalBackgroundImage
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: backgroundColor, // Fallback if image fails
      }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Content Image - Positioned at Top */}
      {(contentImageOne || contentImageOnePreview) && (
        <div className="absolute top-0 left-0 right-0 z-10 flex items-center justify-center w-full pt-8 md:pt-10">
          <div className="w-48 h-48 md:w-64 md:h-64 flex-shrink-0">
            <img
              src={
                contentImageOne instanceof File
                  ? contentImageOnePreview
                  : contentImageOne
              }
              alt="content"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      )}

      {/* Button - Positioned at Bottom */}
      <div className="absolute bottom-0 left-0 right-0 z-10 flex items-center justify-center w-full pb-8 md:pb-10">
        <button
          className={`px-10 py-4 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
            buttonLink ? "cursor-pointer hover:opacity-90" : "cursor-default"
          }`}
          style={{
            backgroundColor: buttonBackgroundColor,
            color: buttonFontColor,
            fontSize: `${buttonFontSize}px`,
            fontFamily: buttonFont,
            fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
            fontStyle: explicitBoleanCheck(buttonIsItalic)
              ? "italic"
              : "normal",
            textDecoration: explicitBoleanCheck(buttonIsUnderline)
              ? "underline"
              : "none",
          }}
          onClick={() => {
            if (buttonLink) {
              window.open(buttonLink, "_blank");
            }
          }}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default CenteredTemplateOneOneEight;
